import { NotificationStrategy, NotificationStrategyMap } from './types';

const strategies = new Map<string, NotificationStrategy>();

export function normalizeNotificationType(rawType: string | null): string | null {
  if (!rawType) {
    return null;
  }

  return rawType
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
}

export function registerNotificationStrategy(
  notificationType: string,
  strategy: NotificationStrategy,
) {
  const normalizedType = normalizeNotificationType(notificationType);

  if (!normalizedType) {
    throw new Error('Cannot register notification strategy without a notification type');
  }

  strategies.set(normalizedType, strategy);
}

export function registerNotificationStrategies(strategyMap: NotificationStrategyMap) {
  Object.entries(strategyMap).forEach(([notificationType, strategy]) => {
    registerNotificationStrategy(notificationType, strategy);
  });
}

export function getNotificationStrategy(rawType: string | null): NotificationStrategy | null {
  const normalizedType = normalizeNotificationType(rawType);

  if (!normalizedType) {
    return null;
  }

  return strategies.get(normalizedType) ?? null;
}
